import { render, staticRenderFns } from "./ImageUploadButton.vue?vue&type=template&id=0338e702&"
import script from "./ImageUploadButton.vue?vue&type=script&lang=js&"
export * from "./ImageUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports